export default {
    AVAILABLE: "AVAILABLE",
    ARCHIVED: "ARCHIVED",
    ARCHIVING: "ARCHIVING",
    RESTORING: "RESTORING",
    RESTORED: "RESTORED",
    UPLOADING: "UPLOADING",
    DELETED: "DELETED",
};
